import doc21 from "../../assets/images/doc21.png";
import doc22 from "../../assets/images/doc22.png";
import doc23 from "../../assets/images/doc23.png";
import doc24 from "../../assets/images/doc24.png";
// import docOne

export const doctors = [
  {
    id: 1,
    img: doc23,
    name: "Dianne Russell",
  },
  {
    id: 2,
    img: doc21,
    name: "Esther Howard",
  },
  {
    id: 3,
    img: doc24,
    name: "Darrell Steward",
  },
  {
    id: 4,
    img: doc22,
    name: "Jenny Wilson",
  },
];
